function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function hasWebMcpSupport() {
  var navigatorRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator;
  return Boolean(navigatorRef && navigatorRef.modelContext && typeof navigatorRef.modelContext.provideContext === 'function');
}
function getTemplateName() {
  var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  if (!body || !body.className) return '';
  var templateClass = body.className.split(/\s+/).find(className => className.indexOf('template-') === 0);
  return templateClass ? templateClass.replace('template-', '') : '';
}
function getCartItemCount() {
  var documentRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var itemCountNode = documentRef.querySelector('[data-item-count]');
  if (!itemCountNode) return null;
  var parsedValue = Number.parseInt(itemCountNode.textContent, 10);
  return Number.isNaN(parsedValue) ? null : parsedValue;
}
function getPrimaryHeading() {
  var documentRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var heading = documentRef.querySelector('main h1, [role="main"] h1, h1');
  return heading ? heading.textContent.trim() : '';
}
function buildStorefrontContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$documentRef = _ref.documentRef,
    documentRef = _ref$documentRef === void 0 ? document : _ref$documentRef,
    _ref$locationRef = _ref.locationRef,
    locationRef = _ref$locationRef === void 0 ? window.location : _ref$locationRef;
  var templateName = getTemplateName(documentRef.body);
  var searchParams = new URLSearchParams(locationRef.search || '');
  var heading = getPrimaryHeading(documentRef);
  return {
    pageTitle: documentRef.title || '',
    pageHeading: heading,
    pageType: templateName || 'unknown',
    url: locationRef.href,
    path: locationRef.pathname,
    searchUrl: '/search',
    cartUrl: '/cart',
    cartItemCount: getCartItemCount(documentRef),
    searchQuery: searchParams.get('q') || ''
  };
}
function buildStoreSearchDestination(query) {
  var locationRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;
  var normalizedQuery = String(query || '').trim();
  if (!normalizedQuery) {
    throw new Error('A non-empty search query is required.');
  }
  var destination = new URL('/search', locationRef.origin);
  destination.searchParams.set('q', normalizedQuery);
  return destination.toString();
}
function requestNavigationConfirmation(_x, _x2, _x3) {
  return _requestNavigationConfirmation.apply(this, arguments);
}
function _requestNavigationConfirmation() {
  _requestNavigationConfirmation = _asyncToGenerator(function* (client, query, destination) {
    var windowRef = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;
    if (!client || typeof client.requestUserInteraction !== 'function' || typeof windowRef.confirm !== 'function') {
      return true;
    }
    return client.requestUserInteraction(/*#__PURE__*/_asyncToGenerator(function* () {
      return Promise.resolve(windowRef.confirm("Open search results for \"".concat(query, "\"?\n").concat(destination)));
    }));
  });
  return _requestNavigationConfirmation.apply(this, arguments);
}
function createWebMcpTools() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$documentRef = _ref2.documentRef,
    documentRef = _ref2$documentRef === void 0 ? document : _ref2$documentRef,
    _ref2$locationRef = _ref2.locationRef,
    locationRef = _ref2$locationRef === void 0 ? window.location : _ref2$locationRef,
    _ref2$windowRef = _ref2.windowRef,
    windowRef = _ref2$windowRef === void 0 ? window : _ref2$windowRef;
  return [{
    name: 'get-storefront-context',
    title: 'Get Storefront Context',
    description: 'Read the current Sitka Seafood Market page context, including page type, heading, search query, and visible cart count.',
    inputSchema: {
      type: 'object',
      properties: {},
      additionalProperties: false
    },
    annotations: {
      readOnlyHint: true
    },
    execute: function () {
      var _execute = _asyncToGenerator(function* () {
        return buildStorefrontContext({
          documentRef,
          locationRef
        });
      });
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    name: 'search-storefront-products',
    title: 'Search Storefront Products',
    description: 'Navigate the active tab to Sitka Seafood Market search results for a product query.',
    inputSchema: {
      type: 'object',
      properties: {
        query: {
          type: 'string',
          description: 'The product or keyword query to search for on the storefront.',
          minLength: 1
        }
      },
      required: ['query'],
      additionalProperties: false
    },
    execute: function () {
      var _execute2 = _asyncToGenerator(function* (_ref3, client) {
        var query = _ref3.query;
        var destination = buildStoreSearchDestination(query, locationRef);
        var confirmed = yield requestNavigationConfirmation(client, String(query).trim(), destination, windowRef);
        if (!confirmed) {
          throw new Error('Storefront search navigation cancelled.');
        }
        windowRef.location.assign(destination);
        return {
          status: 'navigating',
          destination,
          query: String(query).trim()
        };
      });
      function execute(_x4, _x5) {
        return _execute2.apply(this, arguments);
      }
      return execute;
    }()
  }];
}
function initWebMcp() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$navigatorRef = _ref4.navigatorRef,
    navigatorRef = _ref4$navigatorRef === void 0 ? window.navigator : _ref4$navigatorRef,
    _ref4$documentRef = _ref4.documentRef,
    documentRef = _ref4$documentRef === void 0 ? document : _ref4$documentRef,
    _ref4$locationRef = _ref4.locationRef,
    locationRef = _ref4$locationRef === void 0 ? window.location : _ref4$locationRef,
    _ref4$windowRef = _ref4.windowRef,
    windowRef = _ref4$windowRef === void 0 ? window : _ref4$windowRef;
  if (!hasWebMcpSupport(navigatorRef)) {
    return false;
  }
  navigatorRef.modelContext.provideContext({
    tools: createWebMcpTools({
      documentRef,
      locationRef,
      windowRef
    })
  });
  return true;
}
export { buildStoreSearchDestination, buildStorefrontContext, createWebMcpTools, hasWebMcpSupport, initWebMcp };